import React, { useMemo, useContext, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const ActivityTypeDetails = () => {
  const { activityTypeId } = useParams();
  const decodedId = activityTypeId ? atob(activityTypeId) : activityTypeId;
  const id = decodedId ? decodedId.replace(/\D/g, '') : '';
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES.customerActivityType}${id}/` : null;
  const { data: activityType, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!activityType) return [];
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(activityType)
      .filter(k => !excluded.includes(k))
      .map(k => ({ label: k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' '), field: k }));
  }, [activityType]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.customerActivityType}${id}/`);
      showToast('Activity type deleted successfully', 'success');
      navigate('/customer/activity-type/list');
    } catch (error) {
      console.error('Error deleting activity type:', error);
      showToast('Error deleting activity type', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={activityType}
        columns={columns}
        entityName="Activity Type"
        listPath="/customer/activity-type/list"
        editPath={`/customer/activity-type/input/${btoa(activityTypeId)}`}
        onDelete={() => setShowDelete(true)}
        loading={loading}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Activity Type"
        message="Are you sure you want to delete this activity type?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default ActivityTypeDetails;
